import React from 'react';
import { Box, useTheme, lighten, Skeleton } from '@mui/material';
import { Link } from 'react-router';
import { Typography, Button } from '../..';

export interface BreadcrumbProps {
  // render wins if provided. if href exists render a Link. else if onClick, render a button, else plain typography
  label: string;
  render?: () => React.ReactNode;
  href?: string;
  onClick?: () => void;
  isLast?: boolean;
  highlightLastItem?: boolean;
  loading?: boolean;
}
export const Breadcrumb: React.FC<BreadcrumbProps> = ({
  label,
  render,
  href,
  onClick,
  isLast,
  highlightLastItem,
  loading,
}) => {
  const { palette } = useTheme();
  const getItem = () => {
    const styles = {
      color: isLast && highlightLastItem ? palette.primary.main : '#717680',
      fontSize: '14px',
      fontWeight: 600,
      fontStyle: 'normal',
      textDecoration: 'none',
    };
    if (loading) return <Skeleton variant="text" width={100} />;
    if (render) return render();
    if (href) {
      return (
        <Link to={{ pathname: href }} style={styles}>
          {label}
        </Link>
      );
    }
    if (onClick) return <Button onClick={onClick}>{label}</Button>;
    return (
      <Typography sx={styles} variant="body2">
        {label}
      </Typography>
    );
  };
  return (
    <Box
      data-testid="breadcrumb-container"
      sx={{
        backgroundColor: isLast && highlightLastItem ? `${lighten(palette.primary.main, 0.9)}` : 'transparent',
        borderRadius: isLast ? '6px' : '0',
        padding: isLast ? '4px 8px' : '0',
      }}
    >
      {getItem()}
    </Box>
  );
};
